import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// @todo stop hardcoding this, move to config or something
export const HONEYCOMB_THEMES = ['default', 'dark', 'high-contrast', 'kamil', 'legacy', 'neptune'];

export const ThemeContext = React.createContext({
  theme: '',
  setTheme: () => {},
});

const ThemeContextProvider = ({ children }) => {
  const defaultTheme = 'default';
  const [theme, setTheme] = useState(defaultTheme);
  useEffect(() => {
    function loadTheme() {
      const storedTheme = localStorage.getItem('theme');
      return storedTheme || defaultTheme;
    }
    setTheme(loadTheme());
  }, []);
  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeContextProvider;
